class ProgressBar {
  #element;

  constructor(element) {
    this.#element = element;
  }

  setProgress(percent) {
    return new Promise((resolve, reject) => {
      this.#element.value = percent;

      setTimeout(() => resolve(), 600);
    });
  }
}

export {ProgressBar};
